/**
 * @param fullUrl string
 * @param imageCache Object
 */
export default function (fullUrl, imageCache) {
  const image = imageCache && imageCache[fullUrl]
  if (image) {
    let imgSvg = image
    try {
      imgSvg = window.atob(image)
    } catch (e) {
      // if you want to be specific and only catch the error which means
      // the base 64 was invalid, then check for 'e.code === 5'.
      // (because 'DOMException.INVALID_CHARACTER_ERR === 5')
    }
    return `data:image/svg+xml;utf8,${encodeURIComponent(imgSvg)}`
  }
  return fullUrl
}
